/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Insert_Segment_LabelInputs */

const en_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert segment`)
};

const fr_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un segment`)
};

const de_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment einfügen`)
};

const it_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci segmento`)
};

const ru_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить сегмент`)
};

const es_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar segmento`)
};

const zh_cn2_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入段`)
};

const ja_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントを挿入`)
};

const hi_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड सम्मिलित करें`)
};

const pt_pt2_segment_event_group_insert_segment_label = /** @type {(inputs: Segment_Event_Group_Insert_Segment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir segmento`)
};

/**
* | output |
* | --- |
* | "Insert segment" |
*
* @param {Segment_Event_Group_Insert_Segment_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_insert_segment_label = /** @type {((inputs?: Segment_Event_Group_Insert_Segment_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Insert_Segment_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_insert_segment_label(inputs)
	if (locale === "de") return de_segment_event_group_insert_segment_label(inputs)
	if (locale === "it") return it_segment_event_group_insert_segment_label(inputs)
	if (locale === "ru") return ru_segment_event_group_insert_segment_label(inputs)
	if (locale === "es") return es_segment_event_group_insert_segment_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_insert_segment_label(inputs)
	if (locale === "ja") return ja_segment_event_group_insert_segment_label(inputs)
	if (locale === "hi") return hi_segment_event_group_insert_segment_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_insert_segment_label(inputs)
	return en_segment_event_group_insert_segment_label(inputs)
});